import { TrainingInsightFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const useTrainedEmployeesByTeam = (insights: TrainingInsightFragment) => {
  const trainedEmployeesByTeam = insights.trainedEmployeesByTeam
    ? insights.trainedEmployeesByTeam.map((value) => {
        const teamName = value.teamName || i18n.t('trainings.insights.charts.teams.no_name')
        return { name: teamName, value: value.employeeCount }
      })
    : []

  return { trainedEmployeesByTeam }
}
